import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Validatable } from './validatable'
import { FormValidationService } from './form-validation-service'
import * as _ from 'lodash'

export interface ValidatedCheckboxModel {
    value: string
    htmlLabel: string
}

@Component({
    selector: 'ValidatedCheckboxGroup',
    templateUrl: './html-templates/validated-checkbox-group.component.html'
})
export class ValidatedCheckboxGroupComponent extends Validatable<string[]> {
    @Input() options: ValidatedCheckboxModel[]
    @Input()
    set selectedValues(values: string[]) {
        if (values) {
            this._selectedValues = values
        } else {
            this._selectedValues = []
        }
    }
    get selectedValues(): string[] {
        return this._selectedValues
    }

    private _selectedValues: string[] = []

    @Input() label: string
    @Output() onValueChange: EventEmitter<string[]> = new EventEmitter<string[]>()

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }

    getValue(): string[] {
        return this.selectedValues
    }

    getLabel(): string {
        return this.label
    }

    setValue(selectedCheckbox: any) {
        const option = _.find(this.options, (checkboxModel) => checkboxModel.value === selectedCheckbox.target.value)

        if (!this.optionIsSelected(option)) {
            this.selectedValues.push(option?.value || '')
            this.onValueChange.emit(this.selectedValues)
        } else {
            _.pull(this.selectedValues, option?.value)
            this.onValueChange.emit(this.selectedValues)
        }
    }

    private optionIsSelected(option: ValidatedCheckboxModel | undefined) {
        return _.find(this.selectedValues, (value) => value === option?.value)
    }
}
